<div class="container flex flex-col items-center justify-center">
  <div class="w-100 flex flex-col items-start">
    <span class="title">¿Qué hace la despaginación?</span>
    <div class="option flex flex-row gap-4">
      <div class="w-100 flex flex-col gap-2 md:flex-row">
        <img class="coverTypeIcon" [src]="getCoverTypeImage(true)" alt="" />
        <div class="flex flex-col">
          <div class="flex flex-row flex-wrap items-center justify-between">
            <div class="flex flex-row flex-wrap gap-x-2">
              <span class="option_title text-wrap">Despaginación activada</span>
            </div>
          </div>
          <div class="m-y-5 flex flex-row flex-wrap gap-3">
            <span class="title_annotation pink">Desconfigura tu documento</span>
          </div>
          <span class="option_subtext"
            >Después de imprimir la portada por la cara frontal, la cara trasera de esa misma hoja se deja sin imprimir,
            quedando completamente en blanco, eso se hace de forma automática por el sistema cuando está activada la
            opción.</span
          >
          <span class="option_subtext">Es decir:</span>
          <ul class="pl-30">
            <li class="option_subtext">Portada (cara 1) → impresa a color</li>
            <li class="option_subtext">Parte trasera de la portada (cara 2) → en blanco</li>
            <li class="option_subtext">Después empieza el resto del documento en la siguiente hoja</li>
          </ul>
          <span class="option_subtext"
            >📌 Úsalo si… tu archivo NO tiene esa página en blanco detrás de la portada.</span
          >
          <span class="option_subtext"
            >⚠️ No lo uses si… tú mismo ya has puesto una página en blanco en tu diseño, porque quedará una de más y el
            documento se descuadrará (quedará una página de más y el contenido se desplazará).</span
          >
        </div>
      </div>
    </div>

    <div class="option flex flex-row gap-4">
      <div class="w-100 flex flex-col gap-2 md:flex-row">
        <img class="coverTypeIcon" [src]="getCoverTypeImage(false)" alt="" />
        <div class="flex flex-col">
          <div class="flex flex-row flex-wrap items-center justify-between">
            <div class="flex flex-row flex-wrap gap-x-2">
              <span class="option_title text-wrap">Despaginación desactivada</span>
            </div>
          </div>
          <div class="m-y-5 flex flex-row flex-wrap gap-3">
            <span class="title_annotation blue">Tu documento tal y como estaba</span>
          </div>
          <span class="option_subtext"
            >Después de imprimir la portada por la cara frontal, la cara trasera de esa misma hoja se imprime el
            contenido que tenga tu archivo. No se añade ninguna página en blanco automáticamente.</span
          >
          <span class="option_subtext">Es decir:</span>
          <ul class="pl-30">
            <li class="option_subtext">Portada (cara 1) → impresa a color</li>
            <li class="option_subtext">Parte trasera de la portada (cara 2) → se imprime según tu diseño a color</li>
            <li class="option_subtext">
              Después continúa el resto del documento a color o en blanco y negro según hayas configurado tu documento
              en el interior.
            </li>
          </ul>
          <span class="option_subtext"
            >📌 Úsalo si… tu archivo ya tiene la página en blanco detrás de la portada o si quieres que esa cara se
            imprima con contenido.</span
          >
          <span class="option_subtext"
            >⚠️ No lo uses si… quieres que la parte trasera de la portada quede en blanco y tu archivo no contiene una
            página en blanco entre la portada y tu contenido.</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
